const SharedSessionConstants = {
  MAX_FREE_SESSIONS_WEEK: 3,
  MAX_BOOKING_LIMIT: 2000,
  PREMIUM_BOOKING_LIMIT_ATTENDANCE_SCORE: 85,
  MIN_PREMIUM_BOOKING_LIMIT: 3,
  PREMIUM_BAN_ATTENDANCE_SCORE: 60, // potentially changed the minds of 8 people who could have paid 5 dollars to keep one $5 person; sacrifice to save whole herd

  BOOKING_STATUS_CODES: {
    BOOKING_ALLOWED: 0,
    BOOKING_DISABLED: 1, // user's booking limit is 0
    BOOKING_SUSPENDED_BY_ADMIN: 2, // user has been suspended manually by admin
    BOOKING_SUSPENDED_CANCELLATION_ABUSE: 3, // suspended for cancellation abuse
    BOOKING_FROZEN: 4, // user got their account frozen
    BOOKING_ABOVE_LIMIT: 5,
    FIRST_SESSION_LIMIT: 6,
    FREE_SESSIONS_USED: 7,
    BOOKING_ABOVE_FREE_LIMIT: 8,
  },
};

module.exports = SharedSessionConstants;
